module.exports = __webpack_public_path__ + "static/media/twintees.cfd11425.png";